import * as React from 'react';
import type { BookingStep } from '@bondvet/types/booking';
import type { LocationWithCoordinates, OgImage } from 'lib/types';
import GlobalEffects from 'core/components/GlobalEffects';
import SEO from 'core/components/SEO';
import LocationsProvider from 'core/components/LocationsProvider';
import ApolloProvider from 'core/components/ApolloProvider';
import GlobalTrackingPixels from 'analytics/components/GlobalTrackingPixels';
import RestoreBookingSession from '../RestoreBookingSession';
import BookingContextProvider from '../BookingContextProvider';

type BookingPageProps = {
    step: BookingStep;
    page?: {
        title?: string;
        description?: string;
    };
    ogImage?: OgImage;
    pathname?: string;
    citySlug?: string;
    locationSlug?: string;
    location?: LocationWithCoordinates;
};

export default function BookingPage({
    children,
    step,
    ogImage,
    page,
    pathname,
    citySlug,
    locationSlug,
    location,
}: React.PropsWithChildren<BookingPageProps>) {
    return (
        <GlobalEffects>
            <SEO
                title={page?.title ?? 'Book Now'}
                description={page?.description}
                pathname={pathname}
                ogImage={ogImage}
            />
            <LocationsProvider>
                <ApolloProvider>
                    <BookingContextProvider
                        citySlug={citySlug}
                        locationSlug={locationSlug}
                        location={location}
                        step={step}
                    >
                        <RestoreBookingSession step={step}>
                            {children}
                        </RestoreBookingSession>
                    </BookingContextProvider>
                </ApolloProvider>
            </LocationsProvider>
            <GlobalTrackingPixels />
        </GlobalEffects>
    );
}
